"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgbaToHex = exports.isValidHexColor = exports.hexToColor = void 0;
var Color_1 = __importDefault(require("./Color"));
function hexToColor(hex, alpha) {
    if (isValid3DigitHexColor(hex)) {
        hex = convertTo6DigitHexColor(hex);
    }
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result) {
        return new Color_1.default(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), alpha);
    }
    else {
        throw new Error("".concat(hex, " is not a valid hex color."));
    }
}
exports.hexToColor = hexToColor;
function isValidHexColor(colorString) {
    return isValid3DigitHexColor(colorString) || isValid6DigitHexColor(colorString);
}
exports.isValidHexColor = isValidHexColor;
function isValid3DigitHexColor(colorString) {
    var hexColorRegex = /^#(?:[0-9a-fA-F]{3})$/;
    return colorString.match(hexColorRegex);
}
function isValid6DigitHexColor(colorString) {
    var hexColorRegex = /^#(?:[0-9a-fA-F]{6})$/;
    return colorString.match(hexColorRegex);
}
function convertTo6DigitHexColor(threeDigitHex) {
    return threeDigitHex
        .substring(1)
        .split("")
        .map(function (char) {
        return char + char;
    })
        .join("");
}
function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function rgbaToHex(color) {
    var r = Math.floor(color.r * color.a);
    var g = Math.floor(color.g * color.a);
    var b = Math.floor(color.b * color.a);
    return "#".concat(componentToHex(r)).concat(componentToHex(g)).concat(componentToHex(b));
}
exports.rgbaToHex = rgbaToHex;
